import {calculateExpireTime} from 'utilities/helper/expireTime';
import Area from 'assets/images/area/area.svg';

interface PrepaymentCardProps {
  title: string;
  image: string;
  createdDate: string;
  price: number;
  soldTime: string;
  size: number;
  wrapperClassName?: string;
}
const PrepaymentCard = ({
  title,
  image,
  createdDate,
  price,
  size,
  soldTime,
  wrapperClassName,
}: PrepaymentCardProps) => {
  const {daysRemain, hoursRemain, minutesRemain, secondsRemain} =
    calculateExpireTime(soldTime);

  return (
    <>
      <div
        className={`flex bg-white justify-between rounded-lg h-36 mx-2 px-2 py-4  shadow-md w-72 mb-3  ${wrapperClassName}`}
      >
        <div className="relative">
          <span className=" absolute top-2 right-1 text-xs text-created-day bg-white py-1 px-2 rounded-3xl">
            {createdDate}
          </span>
          <img
            className="object-cover  rounded-md flex-none w-[120px] h-[103px]"
            src={image}
            alt={title}
            width={120}
            height={103}
          />
        </div>
        <div className="flex flex-col grow p-2 gap-2 h-full">
          <p className="h-[50%] text-black overflow-hidden max-w-[156px] truncate text-sm font-extrabold text-start">
            {title}
          </p>
          <div className="h-[50%] flex flex-col gap-2 justify-center">
            <div className="flex items-center h-[45%]">
              <span className="icon-presell-manage-ad ml-1 text-[16px] text-primary" />
              <p className=" text-sm text-gray-6 ">
                {price.toLocaleString()} تومان
              </p>
            </div>
            <div className="flex items-center h-[45%] gap-2">
              <img src={Area} alt="area" className="w-[15px] h-[15px]" />
              <p className=" text-sm text-gray-6 ">{size} هکتار</p>
            </div>
            <div className="flex items-center h-[45%] gap-2">
              <span className="icon-clock text-red-1 ml-1 h-full" />
              <p className="font-normal text-sm text-error-1 h-full items-center flex">
                {daysRemain}:{hoursRemain}:{minutesRemain}:{secondsRemain}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrepaymentCard;
